import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import OverlayContainer from "../../Overlay/OverlayContainer";
import {
  clearCart,
  removeCartItem,
  verifyCheckoutSession,
} from "../../../_actions/cart.actions";
import { buildCourseDetailsURI } from "../../../_helpers/utilities";
import { Loading } from "../../Other/Loading";
import TopBar from "../../../Components/Other/TopBar";
import "./cart.css";

const Cart = ({ user, cartItems, loading }) => {
  const [overlay, setOverlay] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const popupCloseHandler = (e) => {
    setOverlay((state) => !state);
  };

  const handleRemoveItem = (event, cartItem, items, countryCode) => {
    event.preventDefault();
    dispatch(removeCartItem(items.cartId, countryCode));
  };

  const handleClearCart = (event) => {
    event.preventDefault();
    dispatch(clearCart());
  };

  const enrollmentCourse = (event, items) => {
    event.preventDefault();
    const country = user?.country_code;
    dispatch(verifyCheckoutSession(items[0]?.SessionID, country, false));
  };

  return (
    <>
      <TopBar />
      <div className="cart-container">
        <div className="cart-header">
          {user && user.userName}'s {t("Shopping Cart")}
        </div>

        {loading ? (
          <Loading />
        ) : cartItems.length > 0 ? (
          <>
            <div className="items-container">
              {cartItems.map((item, index) => (
                <div className="cart-item" key={index}>
                  <div className="card-info">
                    <Link
                      to={buildCourseDetailsURI(
                        item?.SubCategory ? item?.SubCategory : "",
                        item?.CourseName ? item?.CourseName : item?.name,
                        item?.CourseId ? item?.CourseId : item?.BundleId,
                        item?.BundleId
                      )}
                      className="item-description"
                    >
                      <span className="course-title">
                        {item?.CourseName ? item?.CourseName : item?.name}
                      </span>
                    </Link>

                    <div className="instructor-info">
                      {item?.BundleId ? (
                        <div className="apply-coupon apply-coupon-margin">
                          <span className="coupon apply-coupon-margin">
                            Bundle
                          </span>
                        </div>
                      ) : (
                        <>
                          <span>{t("Instructor")}:</span>
                          <span>{item?.Author}</span>
                          {/* {item?.PromoTionalOffer === 1 && (
                          <ApplyCoupon
                            cartItem={item}
                            countryCode={user.country_code}
                            />
                        )} */}
                        </>
                      )}
                    </div>
                  </div>
                  <div className="item-actions">
                    {" "}
                    <a
                      href="javascript(void);"
                      onClick={(event) =>
                        handleRemoveItem(
                          event,
                          cartItems,
                          item,
                          user.country_code
                        )
                      }
                    >
                      {" "}
                      {t("Remove")}
                    </a>{" "}
                  </div>
                  <div className="item-price">$0</div>
                </div>
              ))}
            </div>
            <div className="cart-total">
              <div className="total-inner">
                <div className="total-left">
                  {t("Total")}
                  <span>{cartItems.length}</span> {t("Items")}{" "}
                </div>
                <div className="total-right">
                  {/* {t("SubTotal")}{" "} */}
                  <span>{`${"Enrollement Free"}`}</span>
                  <div className="tax-desc"> </div>
                </div>
              </div>
              <div className="total-inner">
                <div className="actions-left">
                  <a
                    href="javascript(void);"
                    className="btn-empty"
                    onClick={(event) => handleClearCart(event, cartItems)}
                  >
                    {" "}
                    {t("Empty your cart")}
                    <span className="icon-clear-cart"></span>
                  </a>
                </div>
                <div className="actions-right">
                  <a
                    href="#"
                    className="btn-checkout"
                    onClick={(event) => enrollmentCourse(event, cartItems)}
                  >
                    {t("Secure checkout")}{" "}
                    {/* <span className="checkout-desc">
                      YOU WILL BE REDIRECTED TO{" "}
                      <label>
                        {user.country_code === "IN" ? "Razorpay" : "stripe"}{" "}
                      </label>
                    </span> */}
                    <span className="lock-icon"></span>{" "}
                  </a>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="empty-cart">
            <div className="banner-text">
              <div className="banner-header">
                {t("Hey")} <span>{user && user.userName}</span>,{" "}
                {t("Shopping Cart Empty")}
              </div>
              <div className="banner-subheader">
                <Link to="/courses">{t("Find Something Interesting")}</Link>
              </div>
            </div>

            <div className="banner-image"></div>
          </div>
        )}
        {/* {overlay && renderOverlay(overlay)} */}
      </div>

      {overlay && (
        <OverlayContainer>
          <div className="alert-dialog-inner">
            <div className="alert-dialog-close">
              <div>
                <i className="icon check"></i>
              </div>
            </div>
            <div className="alert-title">Warning!</div>
            <div className="alert-message"></div>
          </div>
        </OverlayContainer>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.users;
  const { geoLocation } = state.authentication;
  const { cartItems, loading } = state.cart;
  return {
    user: { ...user, ...geoLocation },
    cartItems,
    loading,
  };
};

export default connect(mapStateToProps)(Cart);
